import { useEffect } from 'react';
import { Application } from '@core/Application';
import { usePopup } from '@contexts/popupContext';
import ResultPopup from '@components/General/ResultPopup';
import { HTTPErrorInfo } from '@shared/core/HTTPClientInterface';

// Mount this once (e.g., inside App) to translate HTTP 403 errors into popups.
export const HTTPErrorListener = () => {
	const { showPopup } = usePopup();

	useEffect(() => {
		const http = Application.shared().coreDependencies.httpClient;

		const handler = (err: HTTPErrorInfo) => {
			if (err.status === 403) {
				const message = "No tienes permisos para realizar esta acción!"
				showPopup(() => (
					<ResultPopup result={message} succesful={false} />
				));
			}
		};

		// attach handler
		const prev = http.onError;
		http.onError = (err: HTTPErrorInfo) => {
			try {
				handler(err);
			} catch {}
			if (typeof prev === 'function')
				try {
					prev.call(http, err);
				} catch {}
		};

		return () => {
			// restore previous to avoid leaks on hot reloads
			http.onError = prev;
		};
	}, [showPopup]);

	return null;
};

export default HTTPErrorListener;
